export default __webpack_public_path__ + "static/911-e20e46071db4a9233e61138ff0aacf4f.gif";